import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

export type StoreWishlistItem = {
  item_id: number;
  product_id?: number | null;
  variant_id?: number | null;
  product_name: string;
  product_slug: string;
  primary_image_url?: string | null;
  variant_name?: string | null;
  price?: string | number | null;
  compare_at_price?: string | number | null;
  product_status: string;
  variant_is_active?: boolean | null;
  created_at: string;
};

export type StoreWishlistListResponse = {
  items: StoreWishlistItem[];
  total: number;
};

export type StoreWishlistAddRequest =
  | {
      product_id: number;
      variant_id?: never;
    }
  | {
      variant_id: number;
      product_id?: never;
    };

export type StoreWishlistActionResponse = {
  ok: boolean;
  item_id?: number | null;
  message: string;
};

type Builder = EndpointBuilder<any, any, any>;

export const storeWishlistApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getStoreWishlist: builder.query<StoreWishlistListResponse, void>({
      query: () => ({
        url: `/store/wishlist`,
        method: "GET",
      }),
      providesTags: ["StoreWishlist"],
    }),

    addStoreWishlistItem: builder.mutation<StoreWishlistActionResponse, StoreWishlistAddRequest>({
      query: (body) => ({
        url: `/store/wishlist`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["StoreWishlist"],
    }),

    removeStoreWishlistItem: builder.mutation<StoreWishlistActionResponse, number>({
      query: (itemId) => ({
        url: `/store/wishlist/${itemId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["StoreWishlist"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetStoreWishlistQuery,
  useAddStoreWishlistItemMutation,
  useRemoveStoreWishlistItemMutation,
} = storeWishlistApi;